module.exports = __webpack_public_path__ + "static/02-57679770dbe69cb522f2f525f9df29b6.jpg";